import Handlebars from "handlebars";

Handlebars.registerHelper("limitArray", function (list, limit) {
  if (!Array.isArray(list)) {
    return [];
  }
  return list.slice(0, limit);
});
